import { ElementType } from 'react'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import SVGImage from '~/components/Image/SVGImage'
import LoaderSkeleton from '~/shared/components/LoaderSkeleton'

interface TrackerCardProps {
  title: string
  value: string | number | null
  icon: ElementType
  isLarge?: boolean
  isLoading?: boolean
  isXPCard?: boolean
}

export default function TrackerCard({
  title,
  value,
  icon,
  isLarge,
  isLoading,
  isXPCard,
}: TrackerCardProps): React.ReactElement {
  return (
    <div
      className={` ${
        isLarge ? 'h-26 lg:h-35 w-41 lg:w-53' : 'h-24 lg:h-35 w-41 lg:w-45'
      }  border rounded-3 border-blue-pastel bg-purple-darker/50`}
    >
      {isLoading ? (
        <LoaderSkeleton className="absolute min-h-full min-w-full rounded bg-transparent" randomStart speed={1200} />
      ) : (
        <div className="flex flex-col items-start justify-between px-5 py-3 lg:px-6 lg:py-6 gap-3 min-w-full min-h-full">
          {isXPCard ? (
            <SVGImage alt="XP" imageClassName="w-5.5 ml-1" srcKey="gamification/xp.svg" />
          ) : (
            <SVGIcon icon={icon} pathClassName="text-green-lime" size={20} />
          )}
          <div className="flex flex-col">
            <p className="text-green-lime leading-4 text-xxs lg:font-semibold">{title}</p>
            <p className="text-md lg:text-lg font-extrabold leading-8 text-white">{value ?? '-'}</p>
          </div>
        </div>
      )}
    </div>
  )
}
